import { render, staticRenderFns } from "./AssignToDialog.vue?vue&type=template&id=27df793a&scoped=true&"
import script from "./AssignToDialog.vue?vue&type=script&lang=ts&"
export * from "./AssignToDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df793a",
  null
  
)

export default component.exports